import { ChangeDetectorRef, Component } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { AuthService } from './core/auth/auth.service';
import { definePreset } from "@primeuix/themes";
import Material from "@primeuix/themes/material";
import { ThemeService } from './core/settings/theme.service';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from './settings.service';
import { Router, RouterModule } from '@angular/router';
import { PushNotificationService } from './pwa-services/push-notification.service';
import { StatusBar } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
import { NativeBadgeCountService } from './pwa-services/native-badge-count.service';




const Purple = definePreset(Material, {
    darkModeSelector: 'dark-mode',

    components: {
        card: {
            body: {
                padding: '0.5px'
            }
        }
    },
    semantic: {
        // primary: {
        //     50: '{cyan.50}',
        //     100: '{cyan.100}',
        //     200: '{cyan.200}',
        //     300: '{cyan.300}',
        //     400: '{cyan.400}',
        //     500: '{cyan.500}',
        //     600: '{cyan.600}',
        //     700: '{cyan.700}',
        //     800: '{cyan.800}',
        //     900: '{cyan.900}',
        //     950: '{cyan.950}'
        // }
        primary: {
            50: '#fbe7fe',   // Very light pastel pink
            100: '#f6bdfd',  // Soft pink
            200: '#f193fb',  // Light magenta
            300: '#f769fa',  // Vibrant pink
            400: '#ed02f5',  // Your color: Bright magenta-purple
            500: '#c002cc',  // Deep magenta-purple
            600: '#9602a3',  // Dark purple-magenta
            700: '#6c027a',  // Plum purple
            800: '#460251',  // Very dark purple
            900: '#270230',  // Midnight purple
            950: '#140118'   // Near black with a purple tint
        }
    },
    primitive: {
        background: {
            main: '#F8F8F8',

        }
    } as any
});

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    imports: [
        RouterModule
    ]
})
export class AppComponent {
    title = 'ammsas-client';

    constructor(
        private primeng: PrimeNG,
        private authService: AuthService,
        public themeService: ThemeService,
        private translate: TranslateService,
        private settingsService: SettingsService,
        private router: Router,
        private pushNotificationService: PushNotificationService,
        private badgeCountService: NativeBadgeCountService,
        private cdr: ChangeDetectorRef,

    ) {
    }

    private isPublicRoute(route: string): boolean {
        const publicRoutes = ['/app/reset-password/', '/app/verify-user/'];
        return publicRoutes.some(publicRoute => route.startsWith(publicRoute));
    }

    private async configureStatusBar() {
        await StatusBar.setOverlaysWebView({ overlay: true });
        StatusBar.show();
    }

    ngOnInit() {
        this.primeng.ripple.set(true);
        if (Capacitor.isNativePlatform()) {
            this.configureStatusBar();
        }

        setTimeout(() => {
            if (!this.isPublicRoute(this.router.url)) {
                this.authService.initializeAuth();
            } else {
                console.log('Skipping auth initialization for public route:', this.router.url);
            }
        }, 500)


        this.themeService.loadTheme();

        this.translate.setFallbackLang('en_US');
        this.settingsService.settings$.subscribe(settings => {

            if (settings?.localeKey) {
                this.translate.use(settings.localeKey);
                this.cdr.detectChanges();
            }
        });
        this.pushNotificationService.subscribeToNotifications();


        this.badgeCountService.increaseBadgeCount(12);
    }

    ngAfterViewInit() {
        this.ensureSafeArea();
        this.cdr.detectChanges();
    }

    private showIosInstallModal(localStorageKey: string): boolean {
        // detect if the device is on iOS
        const isIos = () => {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test(userAgent);
        };

        // check if the device is in standalone mode
        const isInStandaloneMode = () => {
            return (
                "standalone" in (window as any).navigator &&
                (window as any).navigator.standalone
            );
        };

        // show the modal only once
        const localStorageKeyValue = localStorage.getItem(localStorageKey);
        const iosInstallModalShown = localStorageKeyValue
            ? JSON.parse(localStorageKeyValue)
            : false;
        const shouldShowModalResponse =
            isIos() && !isInStandaloneMode() && !iosInstallModalShown;
        if (shouldShowModalResponse) {
            localStorage.setItem(localStorageKey, "true");
        }
        return shouldShowModalResponse;
    }


    private ensureSafeArea() {
        if (!Capacitor.isNativePlatform()) return;

        const root = document.documentElement;

        // Safe Top prüfen
        const safeTop = getComputedStyle(root).getPropertyValue('--safe-top').trim();
        if (safeTop === '0px' || safeTop === '' || safeTop === '0') {
            root.style.setProperty('--safe-top', '40px');
        }

        // Safe Bottom prüfen
        const safeBottom = getComputedStyle(root).getPropertyValue('--safe-bottom').trim();
        if (safeBottom === '0px' || safeBottom === '' || safeBottom === '0') {
            root.style.setProperty('--safe-bottom', '16px');
        }
    }
}
